module.exports = __webpack_public_path__ + "static/media/download.0e8adb14.svg";